import http from '../shared/HttpCommon';
import { Dispatch, SetStateAction } from 'react';
import { CanceledError } from 'axios';
import { IScoreEntry } from '../shared/interfaces/IScoreEntry';

const getLastScores = async (
  platform: string,
  company: string,
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal,
  setStatus?: (status: boolean) => void
) => {
  let data: IScoreEntry[] = [];
  let hasErrors = false;
  const safeSetStatus = (status: boolean) => setStatus?.(status);

  const fetchScore = async (kind?: string) => {
    try {
      const response = await http.post(
        `/${platform}/scores/last`,
        {
          company,
          ...(kind && { kind }),
        },
        { signal }
      );
      data.push(response.data);
    } catch (error) {
      hasErrors = true;
      if (!(error instanceof CanceledError)) {
        console.error(
          `Company "${company}", platform "${platform}" could not be displayed due to an error: ` +
            error
        );
      }
    }
  };

  try {
    loading(true);

    if (platform === 'kununu') {
      const kinds = ['employee', 'applicant', 'total'];
      for (const kind of kinds) {
        await fetchScore(kind);
      }
    } else {
      await fetchScore();
    }
  } catch (error) {
    hasErrors = true;
    if (!(error instanceof CanceledError)) {
      console.error(
        `Company "${company}", platform "${platform}" could not be displayed due to an error: ` +
          error
      );
    }
  } finally {
    loading(false);
  }

  safeSetStatus(!hasErrors);
  return data;
};

const getScores = async (
  platform: string,
  company: string,
  kind: 'total' | 'employee' | 'applicant',
  mode: FilterMode,
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal
) => {
  try {
    loading(true);
    const { data } = await http.post(
      `/${platform}/scores/filter`,
      { company, kind, mode },
      { signal }
    );
    loading(false);
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(
        `Could not fetch scores for company "${company}", platform "${platform}": ` + error
      );
    }
  }
};

const getLastTotalScore = async (
  platform: string,
  company: string,
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal
) => {
  try {
    loading(true);
    const response = await http.post(
      `/${platform}/scores/last`,
      {
        company,
        ...(platform === 'kununu' && { kind: 'total' }),
      },
      { signal }
    );
    return response.data;
  } catch (error) {
    if (!(error instanceof CanceledError)) {
      console.error(
        `Could not fetch score for company "${company}", platform "${platform}": ` + error
      );
    }
  } finally {
    loading(false);
  }
};

const ScoreService = {
  getLastScores,
  getLastTotalScore,
  getScores,
};

export default ScoreService;
